<template>
  <div class="app-wrapper" :class="{hideSidebar:!state.sidebar.opened,hoverSideBar:state.sidebar.minOpen}">
    <!-- 左侧 -->
    <div class="side-wrapper" :class="{hover:!state.sidebar.minOpened,light:theme=='light'}">
      <!-- logo -->
      <div style="height:50px;line-height:50px;" class="logo-box">
        <img src="../assets/img/headtitle.png" alt="">
      </div>
      <!-- logo /-->
      <!-- 左侧导航 -->
      <nav-bar style="padding-bottom: 80px;color: #ffffff;margin-top: 80px">
        <Menu width="220" :theme="theme" :accordion="true" @on-select="selectFn" :active-name="currentPath">
          <div v-for="(item,index) in menu " :key="index" v-if="permissions">
            <Submenu :name="index" v-if="item.children && item.children.length>0 && !item.hidden && (item.permission?permissions[item.permission]:true)">
              <template slot="title">
                <i class="iconfont " :class="item.icon" style="margin-left: 0px"></i>
                <span style="margin-left: -6px">{{$t(item.name)}}</span>
              </template>
              <Menu-item v-for="(sub,i) in item.children" :name="sub.path" :key="i" v-if="!sub.hidden && (sub.permission?permissions[sub.permission]:true)">
                <img style="margin-left: 0px" :src="menuDot"/>
                <span style="margin-left: 0px">{{$t(sub.name)}}</span>
              </Menu-item>
            </Submenu>
            <div v-if="item.permission?permissions[item.permission]:true">
              <Menu-item :name="item.path" :key="index" v-if="item.children.length==0 && !item.hidden && item.level!=0 ">
                <i class="iconfont " :class="item.icon" style="margin-left: 0px"></i>
                <span style="margin-left: -6px"> {{$t(item.name)}}</span>
              </Menu-item>
            </div>
          </div>
        </Menu>
        <!-- <div class="theme-switch" :class="{hidden:!state.sidebar.opened}">
          <i-switch size="large" @on-change="themeChange" v-model="themeBool">
            <span slot="open">Dark</span>
            <span slot="close">Light</span>
          </i-switch>
        </div> -->
      </nav-bar>
      <!-- 左侧导航 /-->
    </div>
    <!-- 左侧 /-->
    <!-- 主体 -->
    <div class="main-wrapper">
      <!-- 头部 -->
      <t-header style="position: relative;z-index: 100;background-color: #FFFFFF;">
        <div style="float:left;margin-left:15px;" slot='left'>
          <!-- 面包屑 -->
          <Breadcrumb separator="/">
            <!-- separator=">"  -->
            <!-- <Breadcrumb-item  class="menuNav" style="margin-left:0px">
              {{ $t("yd.menu.index")}}：
            </Breadcrumb-item> -->
            <Breadcrumb-item v-if="moduleName" class="menuNav">
              <!-- <Icon type="ios-home-outline"></Icon> -->
              {{$t(moduleName)}}
            </Breadcrumb-item>

            <Breadcrumb-item class="menuNav">
              <span v-if="$t(state.router.currentPageName)!=$t('yd.menu.home')||$t(state.router.currentPageName)!=$t('yd.menu.dashboard')">
              {{$t(state.router.currentPageName)}}
              </span>
              <span v-else>
                Unified Management System
              </span>

            </Breadcrumb-item>
          </Breadcrumb>
          <!-- 面包屑 /-->
        </div>

        <Dropdown class="userBox" slot='right' style="margin-right: -30px">
          <a href="javascript:void(0)" style="color: #3A3A3A;">
            <Avatar :src="avatar" style="vertical-align:middle;width: 25px;height: 25px;border-radius: 50%;" v-if="!avatarUrl" />
            <Avatar :src="avatarUrl" style="vertical-align:middle;" v-else />
            <div class="ellipsis" style="display: inline-block; vertical-align:middle; margin-left: 5px; max-width: 100px;" v-if="this.userInfo && this.userInfo.nickname">
              {{this.userInfo.orgName}}
            </div>
            <img style="margin-right: 15px" :src="down" />
          </a>

          <Dropdown-menu slot="list">
            <Dropdown-item  style="text-align: left">
              <img style="vertical-align: middle" :src="versionInfo" />
              <span style="text-align: left">{{ $t("yd.function.version")}}{{tmsVersion}}</span>
            </Dropdown-item>
            <Dropdown-item  @click.native="changePic()" style="text-align: left">
              <img style="vertical-align: middle" :src="replacePic" />
              <span style="text-align: left">{{ $t("yd.function.changePic")}}</span>
            </Dropdown-item>
            <Dropdown-item  @click.native="changePassModel = true" style="text-align: left">
              <img style="vertical-align: middle" :src="changePwd" />
              <span style="text-align: left">&nbsp;&nbsp;{{$t("yd.function.changePwd")}}</span>
            </Dropdown-item>
            <Dropdown-item  @click.native="logout()" style="text-align: left; ">
              <img style="vertical-align: middle" :src="loggou" />
              <span style="">{{ $t("yd.function.logout")}}</span>
            </Dropdown-item>
          </Dropdown-menu>
        </Dropdown>
        <!--<div-->
        <!--class="userBox"-->
        <!--slot='right'-->
        <!--&gt;-->
        <!--<a-->
        <!--href="javascript:void(0)"-->
        <!--@click="passChange"-->
        <!--style="color: #3A3A3A;"-->
        <!--&gt;{{ $t("yd.function.changepass")}}</a>-->
        <!--</div>-->
        <div class="userBox" slot='right'>
          <!--<Dropdown class="userBox" slot='right'>-->
            <!--<a href="javascript:void(0)" style="color: #3A3A3A;">-->
              <!--{{ $t("yd.function.changelanguage")}}-->
            <!--</a>-->
            <!--<Dropdown-menu slot="list" style=" text-align: left;">-->
              <!--<Dropdown-item @click.native="changeLanguage(1)">-->
                <!--<img style="margin: 0px 0px -3px 0px;" :src="chineseImg" />&nbsp;-->
                <!--<font>中文</font>-->
              <!--</Dropdown-item>-->
              <!--<Dropdown-item @click.native="changeLanguage(2)">-->
                <!--<img style="margin: 0px 0px -3px 0px;" :src="englishImg" />&nbsp;-->
                <!--<font> English</font>-->
              <!--</Dropdown-item>-->
            <!--</Dropdown-menu>-->
          <!--</Dropdown>-->
          <Dropdown>
            <div style="background: #ffffff;color: #595959;width: 100px;height: 42px">
            <span v-if="this.langModel=='zh-CN'">
              <img  style="vertical-align: middle" :src="langList[0].str" />
              <span style="">  {{langList[0].lable}}</span>
              <img  :src="down" style=""/>
            </span>
              <span v-if="this.langModel=='en-US'">
              <img  style="vertical-align: middle" :src="langList[1].str" />
              <span style="">  {{langList[1].lable}}</span>
              <img  :src="down" style=""/>
            </span>

              <!--<Icon type="ios-arrow-down"></Icon>-->
            </div>
            <DropdownMenu slot="list" style="text-align: left;">
              <DropdownItem @click.native="changeLanguage(langList[1].value)">
                <img  style="vertical-align: middle" :src="langList[1].str" />
                <span style="">{{langList[1].lable}}</span>
              </DropdownItem>
              <DropdownItem @click.native="changeLanguage(langList[0].value)">
                <img  style="vertical-align: middle" :src="langList[0].str" />
                <span style="">{{langList[0].lable}}</span>
              </DropdownItem>

            </DropdownMenu>
          </Dropdown>
        </div>
        <!--<div class="userBox" slot='right'>-->
          <!--<a href="javascript:void(0)" @click="logout" style="color: #3A3A3A;">{{ $t("yd.function.logout")}}</a>-->
        <!--</div>-->
        <div class="userBox" slot='right' v-if="manage_flag">
          <a href="javascript:void(0)" @click="returnManage" style="color: #3A3A3A;">{{ $t("yd.function.return_manage")}}</a>
        </div>
        <div class="userBox" slot='right'>
          <!--<Dropdown class="userBox" slot='right'>-->
            <!--<a href="javascript:void(0)" style="color: #3A3A3A;">-->
              <!--{{ $t("yd.form.app_version_code")}}-->
            <!--</a>-->
            <!--<Dropdown-menu slot="list" style=" text-align: left;">-->
              <!--<Dropdown-item >-->
                <!--<font>Copyright©2019 Uhome {{this.tmsVersion}}</font>-->
              <!--</Dropdown-item>-->
            <!--</Dropdown-menu>-->
          <!--</Dropdown>-->
        </div>
      </t-header>
      <!-- 头部 /-->
      <!-- 内容部分 -->
      <div class="main-container">
        <container>

          <!-- 路由 -->
          <transition name="fade" mode="out-in" v-if="!$route.meta.nocache">
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
          </transition>
          <transition name="fade" mode="out-in" v-if="$route.meta.nocache">
            <router-view></router-view>
          </transition>
          <!-- 路由/ -->
        </container>
      </div>
    </div>
    <Modal :title="$t('yd.function.changeavatar')" v-model="updateAvatar" :styles="{top: '20px'}" :mask-closable="false" width="500">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="icon-tupian"></Icon>
        <span>{{$t('yd.function.changeavatar')}}</span>
      </p>
      <div class="file-upload">
        <Avatar icon="person" style="vertical-align:middle;width: 200px;height: 200px;border-radius: 50%;font-size: 182px;line-height: 200px;" v-if="!avatarUrl" />
        <Avatar :src="avatarUrl" style="vertical-align:middle;width: 200px;height: 200px;border-radius: 50%;" v-else />
        <Avatar icon="person" style="vertical-align: bottom;" v-if="!avatarUrl" />
        <Avatar :src="avatarUrl" style="vertical-align: bottom;" v-else />
      </div>
      <div slot="footer" style="text-align: center">
        <Upload ref="upload" :show-upload-list="true" :on-success="handleSuccess"
                :on-error="handleError" :format="['jpg','jpeg']"
                :max-size="500" :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload"
                :action="avatarUploadUrl" :with-credentials="true" :headers="headers" :data="params" style="display: inline-block;width:100%;">
          <Button  icon="ios-cloud-upload-outline">{{$t('yd.form.avatarupload')}}</Button>
        </Upload>
      </div>
    </Modal>

    <!--   <Modal
      id="mustChangePassword"
      v-model="mustChangePassword"
      width="580"
      :closable="false"
      :mask-closable="false"
    >
      <p
        slot="header"
        style="color:#f60;text-align:center"
      >
        <Icon type="information-circled"></Icon>
        <span>{{$t('yd.form.updatepass')}}</span>
      </p>
      <div style="text-align:center">
        <Form
          ref="passValidate"
          :model="passValidate"
          :rules="ruleValidate"
        >
          <Form-item
            :label="$t('yd.form.newpasswordtip')"
            prop="newPassword"
          >
            <Input
              v-model="passValidate.newPassword"
              type="password"
              :placeholder="$t('yd.error.password_rule_1')"
              :maxlength="30"
            />
          </Form-item>
        </Form>
      </div>
      <div style="text-align:center">
        <Form
          ref="passValidate"
          :model="passValidate"
          :rules="ruleValidate"
        >
          <Form-item
            :label="$t('yd.form.confirmnewpassword')"
            prop="reNewPassword"
          >
            <Input
              v-model="passValidate.reNewPassword"
              type="password"
              :placeholder="$t('yd.error.password_rule_1')"
              :maxlength="30"
            />
          </Form-item>
        </Form>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="passReset('passValidate')"
        >{{$t('yd.form.submit')}}</Button>
      </div>
    </Modal>-->

    <!-- 修改密码模态框 -->
    <Modal id="changePassModel" v-model="changePassModel" :styles="{top: '20%'}" width="562" :closable="false">
      <p slot="header" style="color:#1d1c1c;text-align:left">
        <span>{{ $t("yd.function.changepass")}}</span>
      </p>
      <div>
        <Form :model="formItem" :label-width="120" ref="formItem" :rules="ruleValidate" style="width: 90%;margin-top:-6px;margin-bottom:34px;">
          <FormItem :label="$t('yd.form.oldpassword')" prop="oldPassword">
            <Input v-model="formItem.oldPassword" type="password" :minlength="8" :maxlength="20" />
          </FormItem>
          <FormItem :label="$t('yd.form.newpassword')" prop="newPassword">
            <Input v-model="formItem.newPassword" type="password" :minlength="8" :placeholder="$t('yd.error.password_rule_1')" :maxlength="20" />
          </FormItem>
          <FormItem :label="$t('yd.form.confirmnewpassword')" prop="confirmPassword" style="margin-top: 20px">
            <Input v-model="formItem.confirmPassword" type="password" :minlength="6" :maxlength="20" />
          </FormItem>
        </Form>
      </div>
      <p slot="footer">
        <Button  @click.native="closeChangePassModel()">{{$t('alert.cancel0')}}</Button>
        <Button type="primary" @click.native="handlePwdModifySubmit(formItem)">{{$t('yd.form.save')}}</Button>
      </p>
    </Modal>

    <Modal id="commonModal" v-model="commonModal" width="300">
      <p slot="header" style="text-align:center;font-size: 14px;">
        <span>{{common_title}}</span>
      </p>
      <p style="text-align:center">{{common_content}}</p>
      <div slot="footer">
        <Button id="common_btn" type="primary" long :loading="modal_loading" @click="conmmon_btn_click">{{common_btn_content}}</Button>
      </div>
    </Modal>
    <!--更换头像模态框-->
    <!--<Modal id="changePicModal" v-model="changePicModal" width="300">
      <el-upload class="avatar-uploader" :action="avatarUploadPath" :headers="headers" list-type="picture"
                 :show-file-list="true" :on-success="handleAvatarSuccess" :on-error="handleAvatarError"
                 :before-upload="beforeAvatarUpload" style="margin-top:10px" ref="avatar">
        <button type="button" class="el-button filter-item el-button&#45;&#45;primary">
          <i class="fa fa-cloud-upload" aria-hidden="true"></i><span>{{$t('yd.personal.user_avatar_upload')}}</span>
        </button>
        <div slot="tip" class="el-upload__tip">{{$t('yd.personal.user_avatar_upload_tip')}}</div>
      </el-upload>
    </Modal>-->
  </div>
</template>
<script>
import Vue from "vue";
import THeader from "@/views/layout/THeader";
import NavBar from "@/views/layout/NavBar";
import Container from "@/views/layout/Container";
import menu from "@/router/menu";
import Cookies from "js-cookie";
import apiList from "@/api/api";
import { mapGetters } from "vuex";
import { SERVER_BASE_URL } from "@/api/config";
import { validatePass } from "@/common/utils/validate";
import axios from "axios";
import md5 from "blueimp-md5";
import router from "@/router";
import store from "@/store";
import chineseImg from "@/assets/img/lang/ic_Chinese.png";
import englishImg from "@/assets/img/lang/ic_EN.png";
import welcome from "@/assets/img/device/defultUserLogo.png";
import down from "@/assets/img/lang/downICON.png";
import menuDot from "@/assets/img/menu-dot.png";
import logoutImg from "@/assets/img/login/logout.png";
import replacePic from "@/assets/img/login/ic_changeProfile.png";
import versionInfo from "@/assets/img/login/ic_versionInfo.png";
import loggou from "@/assets/img/login/ic_loggou.png";
import changePwd from "@/assets/img/login/ic_changePwd.png";
import eventVue from  '../assets/js/eventVue.js'

export default {
  name: "full",
  components: {
    THeader,
    NavBar,
    Container
  },
  data() {
    const validatePassWord = (rule, value, callback) => {
      if (!validatePass(value)) {
        callback(new Error(this.$t("yd.error.password_rule_1")));
      } else {
        callback();
      }
    };

    // Copy From ChangePass.vue
    const validateNewPassword2 = (rule, value, callback) => {
      if (value !== this.formItem.newPassword) {
        callback(new Error(this.$t("yd.error.password_inconsistency")));
      } else {
        callback();
      }
    };

    return {
      langModel:'',
      currentSelectMenu:'',
      currentPath:'/',
      down:down,
      langList:[
        {
          value:'zh-CN',
          lable:'中  文',
          str:chineseImg,
        },
        {
          value:'en-US',
          lable:'English',
          str:englishImg,
        }
      ],
      menuDot:menuDot,
      avatar: welcome, // 默认头像
      logoutImg:logoutImg,
      replacePic:replacePic,
      versionInfo:versionInfo,
      loggou:loggou,
      changePwd:changePwd,
      chineseImg: chineseImg,
      englishImg: englishImg,
      changePassModel: false, // Copy From ChangePass.vue
      commonModal: false,
      common_title: "",
      common_content: "",
      common_btn_link: "",
      common_btn_content: "",
      moduleName: null,
      mustChangePassword: false,
      tmsVersion: "",
      theme: "dark", // 主题
      updateAvatar: false, //头像更新
      uploadList: [],
      themeBool: true,
      modal_loading: false,
      manage_flag: Cookies.get("cutn"),
      passValidate: {
        newPassword: "",
        reNewPassword: ""
      },
      formValidate: {
        check_password: ""
      },
      ruleValidate: {
        newPassword: [
          { required: true, trigger: "change", validator: validatePassWord }
        ],
        reNewPassword: [
          { required: true, trigger: "change", validator: validatePassWord }
        ],
        oldPassword: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("yd.error.password_old"),
            min: 6,
            max: 20
          }
        ],
        confirmPassword: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("yd.error.password_new_more"),
            min: 6,
            max: 20
          },
          { required: true, trigger: "blur", validator: validateNewPassword2 }
        ]
      },
      menu: menu, // 导航菜单
      // Copy From ChangePass.vue
      formItem: {
        oldPassword: "",
        newPassword: "",
        reNewPassword: "",
        confirmPassword: ""
      },
    };
  },
  created() {
    // this.getAfterSaleData();
    //    console.log(Cookies.get("uid"));
    if (Cookies.getJSON("menu")) {
      this.menu = Cookies.getJSON("menu");
    }
    //根据用户uid获取首页数据
    var that = this;
    apiList.getUserList().then(data => {

      // var lang = Vue.config.lang;
      // if (lang==="en-US" || lang ==="en_US"){
        // let newData=this.hideAfterSale(data);
        // data=newData;
        // this.$router.push("/index");
      // }

      // Cookies.set('userInfo', data, {expires: 1 / 3});
      that.$store.commit("SET_USER_INFO", data);
    });
    this.checkUserCompanyInfo();
    this.getTmsVersion();
    var username = this.$route.query.userName;
    // if (username != null) {
    //   this.checkFirstLogin();
    // }
    if (Cookies.get("moduleName")) {
      this.moduleName = Cookies.get("moduleName");
    }
    this.langModel=Vue.config.lang
  },
  computed: {
    ...mapGetters({
      userInfo: "userInfo",
      logo: "logo",
      permissions: "permissions"
    }),
    // permissions () {
    //     return this.userInfo['permissions']?this.userInfo['permissions']:[];
    // },
    state() {
      return this.$store.state.app;
    },
    headers() {
      var uid = Cookies.get("uid");
      var token = Cookies.get("utn");
      return {
        u_id: uid,
        token_id: token
      };
    },
    params() {
      var lang = Vue.config.lang;
      return {
        lang: lang === "en-US" ? "en_US" : "zh_CN"
      };
    },
    avatarUploadUrl() {
      return "/customer/user/avatar_upload";
    },
    avatarUrl() {
      //debug;
      return this.userInfo && this.userInfo.avator;
    }
  },
  methods: {
    //获取售后传来的值
    getAfterSaleData(){
      eventVue.$on("myFun",(message)=>{   //这里最好用箭头函数，不然this指向有问题
        this.currentPath = message
      });
    },

    //英文状态下隐藏售后管理
    hideAfterSale(param){
        param.permissions['/afterSale']=false;
        param.permissions['/afterSale/applyAfterSale']=false;
        param.permissions['/afterSale/serviceProgress']=false;
        return param;
    },
    //第一次登录修改密码提交
    passReset(name) {
      var that = this;
      this.$refs[name].validate(valid => {
        if (valid) {
          var passWord = that.passValidate.newPassword;
          var rePassWord = that.passValidate.reNewPassword;

          // 两次输入的密码不一致
          if (passWord != rePassWord) {
            this.$Message.warning(this.$t("yd.error.password_inconsistency"));
            return;
          }

          var uid = Cookies.get("uid");
          var token = Cookies.get("utn");
          var lang = Vue.config.lang;
          axios
            .post(
              "/customer/user/force/update",
              {
                password: md5(passWord)
              },
              {
                headers: {
                  u_id: uid,
                  token_id: token,
                  lang: lang === "en-US" ? "en_US" : "zh_CN"
                }
              }
            )
            .then(data => {
              if (data.data.code != 0) {
                this.$Message.error(data.data.msg);
                router.replace({ name: "login" });
              } else {
                this.mustChangePassword = false;
                this.logout();
              }
            })
            .catch(error => { });
        }
      });
    },

    //判断是否需要提交信息
    checkUserCompanyInfo() {
      // apiList.getCompanyInfoIsInput().then(data => {
      //   if (data == 1) {
      //     this.$message({message:this.$t('yd.login.login_check_company_input'),type:'error',customClass:'zZindex'});
      //   }
      // })
    },


    //判断用户是否为第一次登录
    checkFirstLogin() {
      //      console.log("userName:" + this.userInfo.userName)
      let par = {
        userName: this.$route.query.userName
        // userName:this.userInfo.userName
      };
      apiList.checkFirstLogin(par).then(data => {
        if (data) {
          this.mustChangePassword = true;

          $("#mustChangePassword .ivu-modal-body").css({ "margin-top": "0px" });
          $("#mustChangePassword .ivu-form-item-label").css({
            padding: "5px 0px 5px 0px"
          });
          $("#mustChangePassword .ivu-modal-header").css({
            "background-color": "#f2f2f2",
            "border-radius": "3px 3px 0px 0px",
            height: "40px"
          });
          $("#mustChangePassword .ivu-modal-footer").css({
            "background-color": "#ffffff",
            "border-radius": "0px 0px 3px 3px",
            "border-top": "0px",
            "padding-top": "0px"
          });
        }
      });
    },
    //查看TMS版本信息
    getTmsVersion() {
      apiList.getTmsVersion().then(
        (data) => {
          this.tmsVersion = data.systemVersionCode;
        }
      )
    },
    // 查看个人信息
    checkUser() {
      this.$router.push("/userInfo");
    },

    /*     changePass () {
        this.$router.push('/changePass')
      },*/
    handleMaxSize() {
      this.$Message.error(this.$t("yd.error.avatar_rule"));
    },
    handleSuccess(response) {
      if (response.code == 0) {
        this.$set(this.userInfo, "avator", ""); //为了vue去监测avator属性
        this.$store.commit("SET_AVATAR", response.data);
        this.updateAvatar = false;
        this.$Message.success(this.$t("yd.tip.operation_success"));
      } else {
        this.$Message.error(response.msg);
      }
    },
    handleError() {
      this.$Message.error(this.$t("yd.tip.operation_fail"));
    },
    handleFormatError() {
      this.$Message.error(this.$t("yd.error.avatar_format_rule"));
    },
    handleBeforeUpload() { },
    /* 改变语言 */
    changeLang() {
      if (this.state.lang.icon === "#icon-yingguo") {
        this.$store.dispatch("setLang", {
          icon: "#icon-zhongguo",
          type: "CN"
        });
      } else {
        this.$store.dispatch("setLang", {
          icon: "#icon-yingguo",
          type: "EN"
        });
      }
      //        window.location.reload()
    },
    /**
     * 选择菜单
     */
    selectFn(a) {
      var navArray = a.split(",");
      if (navArray.length > 1) {
        a = navArray[0];
        this.$store.commit("GET_CURRENT_PAGE_MODULE", navArray[1]);
        this.moduleName = Cookies.get("moduleName");
      } else {
        this.$store.commit("GET_CURRENT_PAGE_MODULE", "");
        this.moduleName = Cookies.get("moduleName");
      }
      this.currentPath=a
      this.$router.push({
        path: a
      });
    },
    /*
     * 打开公共弹窗
     * */
    showModal(title, content, btn_content, btn_link) {
      this.commonModal = true;
      this.common_title = title;
      this.common_content = content;
      this.common_btn_content = btn_content;
      this.common_btn_link = btn_link;

      $("#commonModal .ivu-modal-body").css({
        height: "60px",
        "line-height": "60px",
        padding: "0"
      });
      $("#commonModal .ivu-modal-header").css({
        "background-color": "#f2f2f2",
        "border-radius": "3px 3px 0px 0px",
        height: "40px"
      });
      $("#commonModal .ivu-modal-footer").css({
        "background-color": "#ffffff",
        "border-radius": "0px 0px 3px 3px",
        "border-top": "0px"
      });
    },
    conmmon_btn_click() {
      switch (this.common_btn_link) {
        case "dologout":
          this.dologout();
          break;
        case "returnParentAccount":
          this.returnParentAccount();
          break;
        default:
//          console.log(
//            "Method Not Found,Plase Create Before Use!" + this.common_btn_link
//          );
          this.$Message.error(
            "Method Not Found,Plase Create Before Use!" + this.common_btn_link
          );
      }

      this.commonModal = false;
    },
    /**
     *退出
     */
    dologout() {
      var that = this;
      apiList.logout().then(data => {
        this.$store.commit("CONTROL_CLEAR_USERID_TOKEN");
        that.$store.commit("CLEAR_USERID_TOKEN");
        localStorage.clear()    //清除所有本地缓存
        sessionStorage.clear()  //清除当前会话所有缓存
        that.$Message.success(this.$t("yd.tip.operation_success"));
        that.$router.push("/login");
        //        location.reload();

      });
    },
    logout() {
      this.showModal(
        this.$t("yd.function.logout"),
        this.$t("yd.form.batchlogout_confim_tip"),
        this.$t("yd.form.submit"),
        "dologout"
      );
    },

    returnParentAccount() {
      apiList.returnParentManage().then(data => {
        this.$store.commit("CONTROL_CLEAR_USERID_TOKEN");
        this.$store.commit("CLEAR_USERID_TOKEN");
        this.$store.commit("SET_USERID_TOKEN", data);
        this.$router.push("/");
        location.reload();
      });
    },

    returnManage() {
      this.showModal(
        this.$t("yd.function.return_manage"),
        this.$t("yd.form.batchh_return_parent_account_tip"),
        this.$t("yd.form.submit"),
        "returnParentAccount"
      );
    },
    /**
     * 更改密码
     */
    passChange() {
      this.changePassModel = true;
      $("#changePassModel .ivu-modal-body").css({ "margin-top": "40px" });
      $("#changePassModel .ivu-modal-header").css({
        "background-color": "#ffffff",
        "border-radius": "3px 3px 0px 0px",
        height: "40px"
      });
      $("#changePassModel .ivu-modal-footer").css({
        "background-color": "#ffffff",
        "border-radius": "0px 0px 3px 3px",
      });
      this.formItem.oldPassword="";
      this.formItem.newPassword="";
      this.formItem.reNewPassword="";
      this.formItem.confirmPassword="";
      this.handleReset("formItem");
    },
    // 关闭修改密码弹窗
    closeChangePassModel() {
      this.formItem.oldPassword="";
      this.formItem.newPassword="";
      this.formItem.reNewPassword="";
      this.formItem.confirmPassword="";
      this.handleReset("formItem");
      this.changePassModel = false;
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    themeChange(state) {
      if (state) {
        this.theme = "dark";
      } else {
        this.theme = "light";
      }
    },
    // Copy From ChangePass.vue
    handlePwdModifySubmit(formName) {
      var vm = this;
      vm.$refs.formItem.validate(valid => {
        if (valid) {
          var uid = Cookies.get("uid");
          var token = Cookies.get("utn");
          axios
            .post(
              "/customer/user/update_pass",
              {
                oldPwd: md5(vm.formItem.oldPassword),
                newPwd: md5(vm.formItem.newPassword)
              },
              {
                headers: {
                  u_id: uid,
                  token_id: token
                }
              }
            )
            .then(data => {
              if (data.data.code != 0) {
                this.$Message.error({
                  content: data.data.msg,
                  duration: 3
                });
              } else {
                this.changePassModel = false;
                this.formItem.oldPassword="";
                this.formItem.newPassword="";
                this.formItem.reNewPassword="";
                this.formItem.confirmPassword="";
                this.handleReset("formItem");
                this.$Message.success(this.$t("yd.tip.operation_success"));
              }
            })
            .catch(error => { });
        }
      });

    },
    //切换语言
    changeLanguage(value) {
      if (value == 'zh-CN') {
        Vue.config.lang = "zh-CN";
        store.dispatch("setLang", { icon: "#icon-zhongguo", type: "CN" });
      } else if (value == 'en-US') {
        Vue.config.lang = "en-US";
        store.dispatch("setLang", { icon: "#icon-zhongguo", type: "EN" });
      }
      var lang = Vue.config.lang;
      let par = {
        lang: lang === "en-US" ? "en_US" : "zh_CN"
      };
      apiList.changeOtherLanguage(par).then(() => {
        location.reload();
      });
    },

    changePic(){
      this.updateAvatar = true;
      this.$refs.upload.clearFiles();
    }
  },
//  watch:{
//    currentPath(curVal, oldVal) {
//      if(curVal=='/remoteDeviceAddressMangeBaidu'){
//        this.currentSelectMenu()
//      }
//    }
//  }
}
</script>
<style>
.file-upload {
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: middle;
}
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.menuNav {
  font-size: 14px;
  color: #595959;
  font-family: NotoSansCJK-Regular;
}
.ivu-breadcrumb {
  height: 48px;
  display: table-cell;
  vertical-align: middle;
}
#sticker {
  padding: 18px;
}
.ivu-breadcrumb > span:last-child {
  font-weight: normal;
  color: #595959;
}
.ivu-breadcrumb-item-separator {
  margin: 0 8px;
  color: #595959;
}
.ivu-form .ivu-form-item-label {
  font-size: 13px;
}
  /* 以下样式为公共样式，会被其他页面使用，请勿删除 */
  /* 单行文本不换行*/
  .no-wrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis
  }
</style>



// WEBPACK FOOTER //
// Home.vue?0046a11a